import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import GlobalStyles from './components/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import About from './components/About';
import Goals from './components/Goals';
import Services from './components/Services';
import Team from './components/Team';
import Contact from './components/Contact';
import OurProjects from './pages/OurProjects';
import Latest from './pages/Latest';
import Donate from './pages/Donate';

// Component to scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Component to handle hash navigation
const ScrollToHashElement = () => {
  const location = useLocation();

  useEffect(() => {
    // If the location contains a hash
    if (location.hash) {
      // Get the element by id (removing the # from the hash)
      const element = document.getElementById(location.hash.slice(1));

      // If the element exists, scroll to it
      if (element) {
        setTimeout(() => {
          window.scrollTo({
            behavior: "smooth",
            top: element.offsetTop - 80, // Offset for header
          });
        }, 100);
      }
    }
  }, [location]);

  return null;
};

// Main Home page component that combines all sections
const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <About />
      <Goals />
      <Services />
      <Team />
      <Contact />
    </>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <Header />
        <ScrollToTop />
        <ScrollToHashElement />
        <main style={{ paddingTop: '80px' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-projects" element={<OurProjects />} />
            <Route path="/latest" element={<Latest />} />
            <Route path="/donate" element={<Donate />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
